{
    "warning": "경고!",
    "message": "모르는 코드를 입력하거나 붙여넣지 마세요.\n이 콘솔을 사용하면 해커가 Self-XSS라고 불리는 공격을 사용해 회원님을 사칭하여 개인 정보를 훔쳐 갈 수도 있습니다."
}
